var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 315,
    viewBox: "0 0 400 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.37,
    d: "M50.4795 256.298H10.5317C-0.157471 245.203 -3.01675 227.524 3.36834 213.504C9.45471 200.142 22.5221 191.316 30.4396 178.95C47.337 152.56 39.1696 113.244 62.1315 91.9094C73.609 81.2458 90.1138 78.161 105.739 76.9144C121.363 75.6678 137.51 75.7019 151.958 69.634C169.776 62.1521 183.207 46.0811 201.56 40.0256C222.167 33.2258 246.819 41.711 258.862 59.7496C266.397 71.0365 269.241 85.2174 278.152 95.4554C292.561 112.013 317.947 113.3 335.919 125.904C342.072 130.278 347.232 135.899 351.064 142.401C354.895 148.902 357.312 156.137 358.156 163.635C360.074 181.698 353.209 202.224 364.053 216.81C369.34 223.923 377.913 227.932 383.606 234.719C389.283 241.484 390.881 247.648 389.095 256.295L50.4795 256.298Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.37,
    d: "M60.6884 256.298H20.7414C10.0515 245.203 7.19219 227.524 13.5773 213.504C19.6637 200.142 32.7318 191.316 40.6494 178.95C57.5459 152.56 49.3793 113.244 72.3405 91.9094C83.818 81.2458 100.323 78.161 115.948 76.9144C131.572 75.6678 147.719 75.7019 162.168 69.634C179.986 62.1521 193.417 46.0811 211.769 40.0256C232.377 33.2258 257.029 41.711 269.071 59.7496C276.607 71.0365 279.45 85.2174 288.361 95.4554C302.771 112.01 328.157 113.295 346.129 125.901C352.282 130.275 357.442 135.896 361.274 142.398C365.105 148.899 367.522 156.134 368.366 163.632C370.284 181.695 363.419 202.221 374.263 216.807C379.55 223.919 388.122 227.929 393.816 234.716C399.493 241.48 401.091 247.645 399.305 256.292L60.6884 256.298Z",
    fill: "url(#paint1_linear)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.627 119.626L150.982 119.68H2.42328L2.06635 119.727C0.592087 109.881 8.30479 99.8804 18.0116 97.229C26.5003 94.911 36.4321 96.9732 43.5396 91.7868C49.9099 87.143 51.4928 78.4602 55.6596 71.7697C58.2688 67.5866 61.9247 64.1556 66.2665 61.8155C71.6824 58.9083 78.4407 57.8927 83.9964 60.5208C93.8351 65.1878 95.7206 78.2121 102.3 86.8872C103.767 88.8253 105.614 90.6316 107.965 91.2751C110.13 91.872 112.426 91.4069 114.645 91.0115C121.916 89.7323 130.637 89.8486 135.161 95.6785C137.287 98.4229 138.047 101.943 139.227 105.199C140.406 108.455 142.338 111.812 145.605 112.982C147.172 113.533 148.949 113.548 150.33 114.471C151.991 115.579 152.526 117.556 152.627 119.626Z",
    fill: "url(#paint2_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.585 138.371H218.342C217.671 137.386 217.266 136.245 217.167 135.057C217.068 133.87 217.278 132.677 217.776 131.595C219.056 128.765 221.726 126.843 224.387 125.246C227.048 123.649 229.88 122.168 231.875 119.788C235.7 115.222 235.475 108.671 236.321 102.779C237.314 95.7862 240.247 88.8632 245.539 84.1729C247.662 82.3327 250.044 80.8126 252.607 79.6609C259.862 76.2886 268.847 75.4435 275.629 79.6919C282.116 83.7543 285.297 91.4835 290.954 96.639C292.238 97.9305 293.833 98.8703 295.586 99.3679C300.653 100.531 304.959 95.9412 308.761 92.3983C314.162 87.3669 321.378 83.607 328.702 84.545C337.315 85.6614 343.973 93.0418 347.239 101.081C348.605 104.43 349.645 108.136 352.36 110.516C359.328 116.617 371.091 109.78 379.215 114.214C382.265 115.881 384.305 118.912 385.935 121.982C388.657 127.119 390.563 132.648 391.585 138.371Z",
    fill: "url(#paint3_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.202 234.403H136.738V256.291H106.549V234.403H61.4177V211.974L108.484 143.215H136.738V211.587H149.202V234.403ZM106.549 211.587V198.438C106.549 195.963 106.639 192.625 106.819 188.422C106.848 186.212 106.99 184.005 107.245 181.809H106.392C104.696 185.67 102.703 189.393 100.431 192.947L87.8931 211.587H106.549Z",
    fill: "url(#paint4_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.957 234.409H128.49V256.298H98.3069V234.409H53.1736V211.979L100.239 143.225H128.49V211.596H140.953L140.957 234.409ZM98.3069 211.593V198.445C98.3069 195.969 98.3971 192.631 98.5777 188.429C98.6066 186.219 98.7488 184.012 99.0037 181.816H98.1501C96.4537 185.676 94.4609 189.4 92.1895 192.953L79.649 211.593H98.3069Z",
    fill: "url(#paint5_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M346.21 235.16L341.873 212.755L333.78 214.321L329.637 215.119L316.648 147.99L288.901 153.355L255.761 229.787L260.021 251.812L304.334 243.246L306.855 256.293H337.602L333.971 237.524L338.114 236.726L346.21 235.16ZM291.903 222.415L281.684 224.384L288.978 207.189L290.452 203.708C292.005 199.786 293.253 195.75 294.185 191.637L295.023 191.482C295.191 193.686 295.47 195.88 295.861 198.056C296.481 202.211 297.027 205.506 297.498 207.941L299.996 220.849L291.903 222.415Z",
    fill: "url(#paint6_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M338.118 236.726L333.78 214.329L321.544 216.694L308.547 149.564L288.901 153.355L280.805 154.921L247.665 231.361L251.925 253.379L260.018 251.813L296.238 244.82L298.457 256.293H329.207L325.878 239.091L333.971 237.525L338.118 236.726ZM288.978 207.189C289.126 208.034 289.273 208.801 289.405 209.507L291.903 222.415L273.584 225.958L282.356 205.274C283.91 201.355 285.158 197.322 286.089 193.211L286.927 193.048C287.094 195.253 287.373 197.447 287.765 199.623C288.21 202.584 288.614 205.111 288.978 207.189Z",
    fill: "url(#paint7_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.416 198.941H134.984L123.275 113.283C123.275 113.283 106.359 94.8172 86.9348 91.3596L105.433 89.3672L147.123 90.4991L153.416 198.941Z",
    fill: "#70B8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6707 151.851C80.6707 151.851 70.1957 167.166 74.8466 180.316L94.3317 151.851L91.8014 148.455L80.6707 151.851Z",
    fill: "#111023"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.984 198.94L134.356 202.894C134.356 202.894 128.804 203.669 128.494 211.592H142.935L150.782 203.939L151.514 198.939L134.984 198.94Z",
    fill: "#111023"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.688 113.222L89.5885 112.361L93.3424 147.704L77.6858 153.31L68.6617 109.663C68.0449 107.757 67.8608 105.737 68.1228 103.751C68.3848 101.765 69.0863 99.8619 70.1763 98.1804C71.2663 96.4989 72.7175 95.0811 74.4245 94.03C76.1314 92.9789 78.0513 92.3208 80.0446 92.1036L86.9271 91.3594H86.9348C106.356 94.817 123.275 113.283 123.275 113.283L112.688 113.222Z",
    fill: "#46A0F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1514 14.5728V15.6L68.899 15.7605C68.6642 15.1863 68.3218 14.6622 67.8903 14.2162C66.2182 12.7758 65.0566 11.6439 63.8601 12.3355C62.9577 12.8603 63.0276 15.3272 63.1122 16.4947L59.7051 16.9281L29.5215 20.7516L29.5076 20.6958C31.466 20.2306 32.9845 16.7257 32.9845 12.4618C32.9845 8.25375 31.5102 4.78682 29.5914 4.24414L70.1467 8.81813V14.5783L70.1514 14.5728Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7719 6.44997C31.6874 6.57492 31.6097 6.70431 31.5391 6.8376C31.2043 7.71754 30.8119 8.5745 30.3644 9.40291C29.9689 9.97504 29.4108 10.4155 28.7621 10.6673C28.0649 10.8876 27.3439 11.0237 26.6143 11.0728C26.1254 11.1233 25.6466 11.2458 25.1936 11.4364C25.4264 7.41051 27.0132 4.27926 28.9646 4.17383L29.5947 4.24438C30.0887 4.44461 30.5366 4.74351 30.911 5.12276C31.2854 5.50201 31.5783 5.95364 31.7719 6.44997Z",
    fill: "url(#paint9_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9737 11.7822C32.9598 11.7961 32.9528 11.8101 32.938 11.824C32.4414 12.4884 32.204 13.3203 31.7423 14.0048C31.1915 14.8165 30.3553 15.3916 29.3998 15.6158C28.5254 15.8112 27.581 15.7065 26.7834 16.105C26.3815 16.3181 26.0436 16.634 25.8042 17.0206C25.365 15.5418 25.1479 14.0061 25.1602 12.4636C25.1602 12.114 25.1671 11.7713 25.1951 11.4356C25.6481 11.2451 26.1269 11.1225 26.6158 11.0721C27.3453 11.023 28.0664 10.8869 28.7636 10.6666C29.4122 10.4147 29.9704 9.97429 30.3658 9.40216C30.8134 8.57375 31.2058 7.71679 31.5406 6.83685C31.6112 6.70356 31.6889 6.57417 31.7734 6.44922C32.5353 8.12581 32.9439 9.94109 32.9737 11.7822Z",
    fill: "url(#paint10_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.99 12.4615C32.99 16.7254 31.4715 20.2342 29.5131 20.6955C29.3689 20.7316 29.221 20.7504 29.0724 20.7513C27.7075 20.7513 26.5048 19.269 25.8049 17.0185C26.0443 16.632 26.3823 16.316 26.7841 16.1029C27.5818 15.7044 28.5261 15.8091 29.4006 15.6137C30.3562 15.3906 31.1929 14.8167 31.7446 14.0059C32.2102 13.3213 32.443 12.4895 32.9403 11.8251C32.9551 11.8111 32.9621 11.7972 32.976 11.7832C32.983 12.0073 32.99 12.2305 32.99 12.4615Z",
    fill: "url(#paint11_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0493 10.4336H106.251C105.226 10.7971 104.265 11.3204 103.403 11.9841C103.015 12.3399 103.187 12.9919 103.662 13.8222H94.0493V10.4336Z",
    fill: "#111023"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.089 12.4748V13.8238H114.478C113.971 12.7262 113.546 11.5931 113.205 10.4336H121.089V12.4748Z",
    fill: "#111023"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0491 13.825V14.5731H70.1506V9.63086H94.0491V13.825Z",
    fill: "url(#paint12_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0957 23.0161L65.8349 27.0141C65.8349 27.0141 59.4475 20.3252 59.7051 16.928L63.1122 16.4947C63.0276 15.3271 62.957 12.8603 63.8602 12.3354C65.0567 11.6439 66.2182 12.7758 67.8904 14.2162C68.3219 14.6621 68.6642 15.1863 68.899 15.7605C69.8459 18.1089 70.5811 20.5371 71.0957 23.0161Z",
    fill: "url(#paint13_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6949 4.27136C35.3434 3.50231 34.2067 4.15895 34.555 4.92102C35.6174 7.20384 36.1081 9.71054 35.985 12.225C35.8618 14.7395 35.1285 17.1864 33.8482 19.3547C33.7674 19.5049 33.7484 19.6806 33.7951 19.8446C33.8418 20.0086 33.9506 20.148 34.0985 20.2332C34.2463 20.3184 34.4215 20.3427 34.587 20.301C34.7525 20.2593 34.8952 20.1548 34.9849 20.0098C36.3724 17.6408 37.162 14.9701 37.2857 12.2282C37.4094 9.48624 36.8634 6.7554 35.6949 4.27136Z",
    fill: "#5B2B89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.393 28.2935V32.3473L124.538 27.7617L129.393 28.2935Z",
    fill: "#455674"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.393 32.3477L134.281 36.9612L138.947 41.3647C138.947 41.3647 149.637 33.885 153.785 33.8222C154.069 33.8158 154.352 33.8345 154.632 33.878C158.291 34.3959 160.529 38.6241 159.886 42.6787C159.194 47.0473 159.319 51.8841 155.108 52.6671C150.896 53.4501 132.343 57.9512 132.343 57.9512L112.036 30.4243L114.429 28.7536L119.759 25.0285L120.837 24.2734L123.181 26.4821L124.538 27.7613L129.393 32.3477Z",
    fill: "#5B616B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.503 29.1387L154.634 33.8778C154.354 33.8342 154.071 33.8155 153.788 33.822C149.639 33.8848 138.95 41.3644 138.95 41.3644L134.283 36.961L142.503 29.1387Z",
    fill: "#455674"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.11 52.6667L148.065 71.8333L147.121 90.496C147.121 90.496 146.295 90.6425 144.861 90.8456C138.145 91.803 118.014 94.0955 105.432 89.3633L110.336 66.1778L108.069 47.8927L80.7149 50.9123L63.5452 28.754L65.8326 27.0136L71.0934 23.0156L87.3195 38.8478L112.708 27.7617C113.245 28.1521 113.822 28.4847 114.429 28.754L112.036 30.4239L132.345 57.9501C132.345 57.9501 150.898 53.4567 155.11 52.6667Z",
    fill: "#5B616B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.76 25.0293L114.429 28.7544C113.822 28.4851 113.245 28.1525 112.708 27.7621C111.961 27.2922 111.324 26.6667 110.841 25.9285C110.358 25.1902 110.04 24.3565 109.909 23.4842C109.676 20.8003 105.145 16.4294 103.662 13.8246C103.187 12.9927 103.018 12.3423 103.403 11.9857C104.265 11.3223 105.226 10.7991 106.251 10.4352C109.07 9.31648 112.827 8.55518 113.17 10.2956C113.179 10.3427 113.19 10.3893 113.204 10.4352C113.546 11.5947 113.971 12.7278 114.478 13.8254C116.408 18.3257 119.76 25.0293 119.76 25.0293Z",
    fill: "url(#paint14_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.38
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.065 71.8344C116.991 65.2447 112.036 30.4258 112.036 30.4258L132.346 57.9721L155.11 52.6678L148.065 71.8344Z",
    fill: "#455674"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.329 12.2168C142.986 12.0353 143.648 12.1679 143.916 13.2161C144.532 15.6139 141.838 18.494 141.838 18.494L142.503 29.139L134.283 36.9613L137.501 27.7621L129.393 28.2932L124.538 27.7621L123.181 26.483C123.181 26.483 122.236 17.6552 122.236 12.4757C122.213 11.5241 122.272 10.5722 122.411 9.63051L122.453 9.37855C128.134 10.3368 136.018 8.12109 136.018 8.12109C136.018 8.12109 137.123 18.8715 138.635 19.0599C140.146 19.2483 140.615 13.2161 140.615 13.2161C141.116 12.7752 141.698 12.4358 142.329 12.2168Z",
    fill: "url(#paint15_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M142.392 4.4026L142.329 12.2171C141.698 12.4362 141.116 12.7756 140.615 13.2164C140.615 13.2164 140.149 19.2417 138.635 19.0603C137.12 18.8789 136.018 8.12149 136.018 8.12149C136.018 8.12149 128.134 10.3372 122.453 9.37894V9.37197C120.815 9.19552 119.279 8.4944 118.074 7.37337C113.728 2.79938 115.241 0.208479 121.467 1.62021C127.693 3.03195 140.601 -4.45389 142.392 4.4026Z",
    fill: "#111023"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.501 27.7617L134.283 36.9601L129.395 32.3466V28.2928L137.501 27.7617Z",
    fill: "#F79244"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.911 10.7972C122.502 10.4886 123.152 10.3084 123.818 10.2683C124.485 10.2282 125.152 10.3292 125.776 10.5646C126.579 10.8538 125.974 12.0376 125.18 11.7484C124.767 11.6017 124.328 11.5398 123.891 11.5664C123.453 11.5931 123.025 11.7077 122.633 11.9035C121.879 12.2833 121.148 11.1794 121.911 10.7972Z",
    fill: "#111023"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.053 15.3526C134.579 15.3252 134.972 14.6707 134.931 13.8908C134.89 13.1109 134.431 12.5009 133.905 12.5284C133.379 12.5559 132.986 13.2104 133.027 13.9903C133.067 14.7702 133.527 15.3801 134.053 15.3526Z",
    fill: "#111023"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M135.643 10.4805C135.022 10.2359 134.357 10.1251 133.69 10.1552C133.023 10.1854 132.371 10.356 131.775 10.6557C131.006 11.027 131.731 12.138 132.491 11.7713C132.887 11.5826 133.316 11.4755 133.754 11.4565C134.193 11.4374 134.63 11.5068 135.041 11.6604C135.831 11.9581 136.441 10.7813 135.643 10.4805Z",
    fill: "#111023"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M126.437 18.3147C126.86 16.3114 127.897 14.2725 128.597 12.3452C128.743 11.9444 129.334 12.2468 129.19 12.6429L127.865 16.2866C127.624 16.7865 127.433 17.3093 127.297 17.8472C127.153 19.3597 127.845 19.2427 128.628 19.6055C129.016 19.7861 128.717 20.3807 128.331 20.1978C127.368 19.7497 126.146 19.6892 126.437 18.3147Z",
    fill: "#F79244"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.705 14.1079C125.1 13.6052 124.366 13.2829 123.586 13.1776C123.098 13.1148 122.896 13.8644 123.391 13.928C123.785 13.9779 124.168 14.0916 124.525 14.2645L123.284 14.6676C122.81 14.8226 123.008 15.5708 123.484 15.4165L125.529 14.7529C125.775 14.6738 125.948 14.3001 125.705 14.1079Z",
    fill: "#111023"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M128.912 26.7162C129.866 26.7162 130.639 25.6009 130.639 24.2253C130.639 22.8496 129.866 21.7344 128.912 21.7344C127.959 21.7344 127.186 22.8496 127.186 24.2253C127.186 25.6009 127.959 26.7162 128.912 26.7162Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M366.741 256.297H55.3934C55.3934 256.297 38.638 267.409 63.5453 269.29C88.4525 271.171 127.298 272.949 126.34 281.416C125.382 289.882 102.889 288.21 102.889 303.158C102.889 318.105 206.63 314.656 206.63 314.656C206.63 314.656 265.235 315.422 273.581 305.527C281.927 295.632 249.955 286.573 255.758 282.67C261.56 278.768 303.687 290.475 309.964 280.998C316.241 271.521 308.708 265.528 320.284 264.273C331.859 263.019 364.788 267.554 366.741 256.297Z",
    fill: "url(#paint16_linear)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M343.201 282.67C356.202 282.67 366.741 279.675 366.741 275.981C366.741 272.286 356.202 269.291 343.201 269.291C330.201 269.291 319.662 272.286 319.662 275.981C319.662 279.675 330.201 282.67 343.201 282.67Z",
    fill: "url(#paint17_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5689 286.852C103.932 286.852 113.144 284.575 113.144 281.765C113.144 278.955 103.932 276.678 92.5689 276.678C81.2055 276.678 71.9937 278.955 71.9937 281.765C71.9937 284.575 81.2055 286.852 92.5689 286.852Z",
    fill: "url(#paint18_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M210.505 306.085C223.411 306.085 233.873 304.073 233.873 301.591C233.873 299.108 223.411 297.096 210.505 297.096C197.599 297.096 187.136 299.108 187.136 301.591C187.136 304.073 197.599 306.085 210.505 306.085Z",
    fill: "#E9FDFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M241.414 196.475C236.619 185.518 227.626 178.696 214.435 176.008C212.999 175.714 211.595 175.481 210.222 175.311C198.583 173.838 188.985 176.613 181.427 183.637C172.969 191.483 166.726 205.259 162.696 224.966C160.229 237.036 159.541 247.479 160.632 256.294H189.466C189.101 251.146 190.115 242.732 192.507 231.051C195.091 218.423 197.652 209.892 200.189 205.46C201.663 202.887 203.331 201.189 205.194 200.367C206.558 199.768 208.078 199.621 209.531 199.948C213.225 200.708 215.351 203.708 215.909 208.949C216.468 214.19 215.493 222.95 212.984 235.23C211.098 244.43 209.208 251.451 207.312 256.294H238.923C240.489 251.377 241.779 246.376 242.787 241.316C243.524 237.711 244.104 234.253 244.525 230.943C246.333 216.833 245.296 205.344 241.414 196.475Z",
    fill: "url(#paint19_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.337 194.832C229.03 184.994 221.325 178.487 210.222 175.311C208.972 174.954 207.682 174.639 206.35 174.365C192.802 171.597 181.8 174.14 173.342 181.993C164.892 189.849 158.651 203.626 154.619 223.322C153.796 227.33 153.173 231.163 152.749 234.819C151.804 241.947 151.814 249.169 152.78 256.294H181.575C181.536 256.108 181.512 255.922 181.489 255.728C180.884 250.712 181.862 241.939 184.422 229.408C187.009 216.779 189.572 208.251 192.112 203.825C194.646 199.39 197.76 197.553 201.454 198.313C202.889 198.578 204.201 199.298 205.194 200.367C206.629 201.902 207.498 204.212 207.832 207.306C208.391 212.554 207.415 221.314 204.907 233.587C202.796 243.882 200.678 251.451 198.552 256.294H230.31C232.115 250.851 233.584 245.302 234.71 239.68C238.582 220.733 238.124 205.783 233.337 194.832Z",
    fill: "url(#paint20_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M255.346 120.952L255.152 121.099L234.877 136.868L222.222 146.706L211.685 175.84L208.76 174.785L219.615 144.806L253.445 118.502L255.346 120.952Z",
    fill: "#2A2A2A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M265.061 186.337C262.756 189.074 259.614 190.95 256.534 192.772L256.324 192.407C257.542 190.849 258.83 189.02 258.466 187.074C258.096 185.77 257.311 184.621 256.231 183.802C254.532 182.306 252.638 181.042 251.017 179.468C249.303 177.964 248.154 175.921 247.758 173.677C247.416 170.731 249.007 167.948 249.628 165.049C249.943 163.897 249.897 162.677 249.496 161.552C248.456 159.087 245.314 158.521 242.823 157.529C240.596 156.629 238.501 154.963 237.88 152.645C236.98 149.28 239.378 145.838 239.052 142.373C238.908 141.167 238.446 140.022 237.712 139.055C236.978 138.087 236 137.333 234.877 136.868L255.152 121.1C258.59 124.077 261.554 128.023 261.593 132.527C261.608 135.38 260.452 138.093 259.629 140.822C259.235 141.9 259.097 143.054 259.226 144.194C259.544 145.915 260.918 147.218 262.182 148.435C264.797 150.939 267.428 153.986 267.381 157.606C267.334 161.669 263.866 165.289 264.471 169.305C264.859 171.871 266.838 173.918 267.629 176.383C268.716 179.794 267.365 183.6 265.061 186.337Z",
    fill: "#455674"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 192.946,
    y1: 267.228,
    x2: 196.873,
    y2: 77.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 203.155,
    y1: 267.228,
    x2: 207.082,
    y2: 77.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 77.256,
    y1: 120.273,
    x2: 77.256,
    y2: 87.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 303.841,
    y1: 143.419,
    x2: 304.102,
    y2: 111.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 61.4177,
    y1: 199.753,
    x2: 149.202,
    y2: 199.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 97.8554,
    y1: 263.76,
    x2: 96.5451,
    y2: 221.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 250.605,
    y1: 207.99,
    x2: 338.341,
    y2: 207.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 293.434,
    y1: 259.922,
    x2: 292.175,
    y2: 217.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 29.5076,
    y1: 12.4979,
    x2: 70.1514,
    y2: 12.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ADC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#54AEC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#74BEB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#8ECCA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A4D79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B5E094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#C1E68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#C8EA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAEB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 31.7719,
    y1: 7.80511,
    x2: 25.1936,
    y2: 7.80511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#88E9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#84E2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7CD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#71C5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#63AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5295F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 32.9737,
    y1: 11.7349,
    x2: 25.1597,
    y2: 11.7349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 32.99,
    y1: 16.2673,
    x2: 25.8049,
    y2: 16.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#88E9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#84E2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7CD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#71C5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#63AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5295F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 70.1506,
    y1: 12.102,
    x2: 94.0491,
    y2: 12.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 59.6975,
    y1: 19.5705,
    x2: 71.0957,
    y2: 19.5705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F7BC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#F7B67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#F7AC6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#F79E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 103.19,
    y1: 19.011,
    x2: 119.76,
    y2: 19.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F7BC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#F7B67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#F7AC6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#F79E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 122.231,
    y1: 22.5412,
    x2: 144.008,
    y2: 22.5412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F7BC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#F7B67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#F7AC6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#F79E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 207.36,
    y1: 317.113,
    x2: 207.392,
    y2: 259.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#88E9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#84E2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7CD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#71C5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#63AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5295F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 343.201,
    y1: 313.403,
    x2: 343.201,
    y2: 262.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#88E9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#84E2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7CD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#71C5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#63AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5295F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 92.5689,
    y1: 313.407,
    x2: 92.5689,
    y2: 262.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#88E9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#84E2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7CD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#71C5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#63AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5295F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 172.066,
    y1: 219.028,
    x2: 253.742,
    y2: 219.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#35C5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3CB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 195.274,
    y1: 261.855,
    x2: 194.466,
    y2: 219.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 315,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.3cf0f886455703af477856f084dba5b2.svg";
export { ForwardRef as ReactComponent };